import { FinishReason } from "@perceptron/api/apiContracts/chatCompletions";
import { strings } from "@perceptron/constants";
import { Icon } from "@perceptron/ui/components/icon";

const FINISH_REASON_MESSAGES: Record<string, string> = {
  length: strings.finishReason.length,
  tool_error: strings.finishReason.toolError,
  tool_limit: strings.finishReason.toolLimit,
};

export function FinishReasonBanner({ finishReason }: { finishReason: FinishReason }) {
  const message = FINISH_REASON_MESSAGES[finishReason];
  if (!message) return null;

  return (
    <div className="my-6 flex w-full animate-fade-in items-center gap-3 rounded-lg bg-background-error p-1">
      <div className="flex items-center gap-2 rounded-3xl bg-background-error px-2 py-1">
        <Icon className="h-4 w-4 text-foreground-primary" name="alert-triangle" />
        <span className="font-normal text-foreground-primary label-2">{strings.finishReason.error}</span>
      </div>
      <span className="ml-auto mr-3 text-foreground-primary label-2">{message}</span>
    </div>
  );
}
